/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ carrier: NonNullable<unknown> }} Carrier_Notices_Dialog_DescriptionInputs */

const en_carrier_notices_dialog_description = /** @type {(inputs: Carrier_Notices_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This notice will be matched to ${i?.carrier} quotes during checkout.`)
};

const es_carrier_notices_dialog_description = /** @type {(inputs: Carrier_Notices_Dialog_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este aviso se mostrara en cotizaciones de ${i?.carrier} durante checkout.`)
};

/**
* | output |
* | --- |
* | "This notice will be matched to {carrier} quotes during checkout." |
*
* @param {Carrier_Notices_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_dialog_description = /** @type {((inputs: Carrier_Notices_Dialog_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Dialog_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_dialog_description(inputs)
	return es_carrier_notices_dialog_description(inputs)
});